<template>
  <div class="row activity activity-featured" @click="emitSelectedActivity()">
    <div class="col-md-8">
      <strong>{{ calendarContent.displayName }}</strong>
      <br />
      <span class="activityAdditionalInfo">{{ calendarContent.locationName }}</span>
    </div>
    <div
      class="col-md-3">
      <ul class="list-unstyled" v-if="!activityDaySchedule.isAllDayEvent && !activityDaySchedule.toBeDetermined">
        <li v-for="schedule in activityDaySchedule.schedules" :key="schedule.sortKey">
          <span v-if="schedule.prependText">{{schedule.prependText}}</span> {{ schedule.displayStart }}
          <span v-if="schedule.displayEnd">&mdash; {{ schedule.displayEnd }}</span> <span v-if="schedule.appendText">{{schedule.appendText}}</span>
        </li>
      </ul>
      <ul class="list-unstyled" v-if="activityDaySchedule.isAllDayEvent">
        <li>All Day</li>
      </ul>
      <ul class="list-unstyled" v-if="activityDaySchedule.toBeDetermined">
        <li>TBD</li>
      </ul>
    </div>
    <div class="col-md-1 text-right pr-0">
      <button class="btn desktop-only">
        <i class="fa fa-chevron-right"></i>
      </button>
      <button class="btn mobile-only w-100 text-center">
        <a @click="emitSelectedActivity()"><i class="fa fa-chevron-down"></i></a>
      </button>      
    </div>
  </div>  
</template>

<script lang="ts">
import { defineComponent, inject, computed, toRef } from 'vue';
import * as CalendarModel from "../composables/calendar-model";
import * as ContentModel from "../composables/calendar-content-model";

export default defineComponent({
  props: {
    activityDaySchedule: { type: Object as () => CalendarModel.ActivityDayScheduleDto, required: true }
  },
  emits: [ CalendarModel.Event.ActivitySelected ],
  setup(props, context) {
    // Static Properties
    const contentLookup = inject(ContentModel.ContentLookup)!;

    // Reactive Properties
    const refActivity = toRef(props, 'activityDaySchedule');
    const calendarContent = computed(() => contentLookup.value.activityById[refActivity.value.extCalendarId] );
   
    // Data setup

    // Events
    const emitSelectedActivity = function() {
      context.emit(CalendarModel.Event.ActivitySelected, calendarContent.value, refActivity.value)
    }

    // Queries

    // Reactions

    // return Model
    return {
      calendarContent,
      emitSelectedActivity
    }
  }
});

</script>
